.period-selector__container {
  display: flex;
  flex-wrap: wrap;
}

.period-selector__container--label-left {
  flex-direction: row;
  gap: 1rem;
  align-items: baseline;
}

.period-selector__container--label-top {
  align-items: flex-start;
  flex-direction: column;
  gap: 0.5rem;
}

.period-selector__selector-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.period-selector__selector-row {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
